import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarTodosGruposClientes(api) {
    let parametros = {
      operacao: 'buscarTodosGruposClientes'
    }
    
    let retorno = {};
    
    await api.santriGET('/rest/grupoCliente', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })
  
    return retorno;
  },

  async buscarGrupoClientesPorId(api, parametros) {
    parametros.operacao = 'buscarGrupoClientesPorId';

    let retorno = {};

    await api.santriGET('/rest/grupoCliente', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RGrupoCliente.js